import { Button, Modal, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import React, { ReactElement, useState } from 'react';

import type {
  MemberFreezeDetailResponse,
  MemberFreezeResponse,
} from '../types';
import styles from './index.module.scss';
import { getFreezeDetailData, numberToChinese } from '../helper';
import {
  type ErrorResponse,
  asyncErrorHandler,
} from '@/utils/asyncErrorHandler';

interface FreezeDetailProps {
  record: MemberFreezeResponse;
}

const { Text } = Typography;

const FreezeDetail = ({ record }: FreezeDetailProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [freezeDetail, setFreezeDetail] =
    useState<MemberFreezeDetailResponse>();

  const showFreezeDetail = async () => {
    const { _id, subscriptionPlanId } = record;
    try {
      const data = await getFreezeDetailData(_id, subscriptionPlanId);
      setFreezeDetail(data);
      setIsOpenModal(true);
    } catch (error) {
      const errObj: ErrorResponse = error.response.data;
      asyncErrorHandler(errObj);
    }
  };

  return (
    <>
      <Button type="primary" onClick={showFreezeDetail}>
        查看凍結
      </Button>
      <Modal
        open={isOpenModal}
        centered
        destroyOnClose
        title="查看凍結"
        footer={null}
        onCancel={() => setIsOpenModal(false)}
      >
        <Space direction="vertical" size="middle" className={styles.widthFull}>
          <div className={styles.fieldContainer}>
            <Text type="secondary">剩餘凍結次數</Text>
            <span>{freezeDetail?.freezeCountLeft + '次'}</span>
          </div>
          <div className={styles.fieldContainer}>
            <Text type="secondary">凍結剩餘天數</Text>
            <span>
              {dayjs(freezeDetail?.freezeDurationLeft).diff(dayjs(0), 'day') +
                '天'}
            </span>
          </div>
          <div className={styles.fieldContainer}>
            <Text type="secondary">狀態</Text>
            <span>{record.status}</span>
          </div>
          {freezeDetail?.freezeHistory.reduce(
            (elements: ReactElement[], data, index) => {
              const format = 'YYYY/MM/DD';
              const chineseNumber = numberToChinese(index);
              const element = (
                <div
                  key={data.freezeStartTime}
                  className={styles.fieldContainer}
                >
                  <Text type="secondary">
                    {index !== 0
                      ? '第' + chineseNumber + '次凍結時間'
                      : '首次凍結時間'}
                  </Text>
                  <span>
                    {dayjs(data.freezeStartTime).format(format) +
                      ' - ' +
                      dayjs(data.freezeEndTime).format(format)}
                  </span>
                </div>
              );
              elements.push(element);

              return elements;
            },
            []
          )}
          <div className={styles.footerButtonContainer}>
            <Button onClick={() => setIsOpenModal(false)}>確認</Button>
          </div>
        </Space>
      </Modal>
    </>
  );
};

export default FreezeDetail;
